import { forwardRef as D } from "react";
import { useThemeUI as H } from "theme-ui";
import * as p from "@radix-ui/react-dialog";
import { ChevronLeft24Icon as h, Cross24Icon as f, ArrowLeft32Icon as j, Cross32Icon as z } from "@material-bank/mb-icons";
import { actionsContainer as g } from "./styles.js";
import { useResponsiveValue as x } from "../../../../lib/css/css-hooks.js";
import "../../../../lib/css/match-media-context.js";
import "@theme-ui/css";
import { jsxs as r, jsx as t } from "theme-ui/jsx-runtime";
import { Stack as e } from "../../../Stack/Stack.js";
import { IconButton as S } from "../../../Button/IconButton/IconButton.js";
import "@material-bank/ds-utils";
import { Text as N } from "../../../Typography/Text.js";
const P = D((u, C) => {
  const {
    children: B,
    dialogVariant: o,
    titleVariant: I,
    displayCloseButton: n,
    leftActions: a,
    rightActions: l,
    backIcon: k,
    closeIcon: A,
    titleSx: y,
    titleWithLeftActionsSx: v,
    actionsContainerSx: s,
    leftActionsSx: R,
    rightActionsSx: b,
    onBackButtonClick: c,
    ...w
  } = u, m = c !== void 0, i = m || !!a, d = n || !!l, {
    theme: L
  } = H(), T = x([h, j]) ?? h, V = x([f, z]) ?? f;
  return /* @__PURE__ */ r(e, {
    ...w,
    direction: "row",
    gap: 4,
    ref: C,
    sx: {
      ...L.dialogHeader[o],
      ...(i || d) && {
        px: [14, 18]
      }
    },
    children: [i && /* @__PURE__ */ r(e, {
      direction: "row",
      gap: 1,
      sx: {
        ...g,
        ...o === "modal" && {
          left: [4, 8]
        },
        ...o === "fullScreenRightSide" && {
          left: 4
        },
        ...(o === "bottomSheet" || o === "modalBottomSheet") && {
          left: 4
        },
        ...s,
        ...R
      },
      children: [m && /* @__PURE__ */ t(S, {
        size: "md",
        variant: "ghost",
        icon: k ?? /* @__PURE__ */ t(T, {
          sx: {
            color: "primary"
          }
        }),
        onClick: c,
        "aria-label": "Back"
      }), a]
    }), /* @__PURE__ */ t(p.Title, {
      asChild: !0,
      children: /* @__PURE__ */ t(N, {
        variant: I ?? ["title4", null, "headline1"],
        sx: {
          ...y,
          ...i && v
        },
        children: B
      })
    }), d && /* @__PURE__ */ r(e, {
      direction: "row",
      gap: 1,
      sx: {
        ...g,
        ...o === "modal" && {
          right: [4, 8]
        },
        ...o === "fullScreenRightSide" && {
          right: 4
        },
        ...(o === "bottomSheet" || o === "modalBottomSheet") && {
          right: 4
        },
        ...s,
        ...b
      },
      children: [l, n && /* @__PURE__ */ t(p.Close, {
        asChild: !0,
        children: /* @__PURE__ */ t(S, {
          size: "md",
          variant: "ghost",
          icon: A ?? /* @__PURE__ */ t(V, {
            sx: {
              color: "primary"
            }
          }),
          "aria-label": "Close"
        })
      })]
    })]
  });
});
P.displayName = "DialogHeader";
export {
  P as DialogHeader
};
